const WEEKDAY_ORDER = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
];

const DAY_ALIASES: Record<string, string> = {
  mon: 'monday',
  monday: 'monday',
  tue: 'tuesday',
  tues: 'tuesday',
  tuesday: 'tuesday',
  wed: 'wednesday',
  wednesday: 'wednesday',
  thu: 'thursday',
  thur: 'thursday',
  thurs: 'thursday',
  thursday: 'thursday',
  fri: 'friday',
  friday: 'friday',
  sat: 'saturday',
  saturday: 'saturday',
  sun: 'sunday',
  sunday: 'sunday',
};

const WEEKDAY_RANK = WEEKDAY_ORDER.reduce<Record<string, number>>((acc, day, index) => {
  acc[day.toLowerCase()] = index;
  return acc;
}, {});

export function normalizeConsultationDay(day: string): string {
  const key = String(day || '').trim().toLowerCase().replace(/\./g, '');
  const alias = DAY_ALIASES[key];
  if (alias) {
    const full = WEEKDAY_ORDER.find((d) => d.toLowerCase() === alias);
    if (full) return full;
  }
  const fullMatch = WEEKDAY_ORDER.find((d) => d.toLowerCase() === key);
  return fullMatch || String(day || '').trim();
}

export function sortConsultationDays(days: string[]): string[] {
  const seen = new Set<string>();
  const normalized: { label: string; rank: number; originalIndex: number }[] = [];

  days.forEach((day, originalIndex) => {
    const trimmed = String(day || '').trim();
    if (!trimmed) return;
    const label = normalizeConsultationDay(trimmed);
    const key = label.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    normalized.push({
      label,
      rank: WEEKDAY_RANK[key] ?? 99 + originalIndex,
      originalIndex,
    });
  });

  return normalized
    .sort((a, b) => a.rank - b.rank || a.originalIndex - b.originalIndex)
    .map((item) => item.label);
}
